import React from 'react';

const OfflineBanner: React.FC = () => {
  const [online, setOnline] = React.useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  React.useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-yellow-600 text-white text-center py-2 text-sm"
      role="status"
      aria-live="polite"
    >
      You are offline. Some features may be unavailable.
    </div>
  );
};

export default OfflineBanner;
